/* NOTE:
global This file can be replaced during build by using the `fileReplacements` array.
`ng build` replaces `environment.ts` with `environment.prod.ts`.
The list of file replacements can be found in `angular.json`. */
import { Environment, EnvironmentType } from '@fleet-beat/core';

export const environment: Environment = {
  type: EnvironmentType.PROD,
  identityApiUrl: 'https://dev.api.silverlineeld.com/identity',
  tenantsApiUrl: 'https://dev.api.silverlineeld.com/tenants',
  tenantsHubUrl: 'https://dev.api.silverlineeld.com/tenants-hub',
  assetsApiUrl: 'https://dev.api.silverlineeld.com/assets',
  assetsHubUrl: 'https://dev.api.silverlineeld.com/assets-hub',
  mapsApiUrl: 'https://dev.api.silverlineeld.com/maps',
  mapsHubUrl: 'https://dev.api.silverlineeld.com/maps-hub',
  metricsApiUrl: 'https://dev.api.silverlineeld.com/metrics',
  mapboxAccessToken:
    'pk.eyJ1Ijoic2lsdmVybGluZS1lbGQiLCJhIjoiY21wcGx5dDQzMGJqbDJxc2Z5bTNnb2RoZyJ9.66gvo_nzQo2Ccs3PebzzfQ',

  // eslint-disable-next-line no-comments/disallowComments
  // ----------   new API
  apiEndpoint: 'https://dev.api.silverlineeld.com/api/v1',
  messagingHubUrl: 'wss://dev.api.silverlineeld.com',
  stripeKey:
    'pk_test_51PiGRQHYKxx2Z7zfPEMmMCDKxzaFU2WaxdA8a9Wv0wpO35FJ8PqoUj89fmjzx0nfmIRxB59gx7sNkvRAJFwp8UAU00w7epPaVF',
};

/* NOTE:
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// NOTE: import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
